import React from "react";
import styled from "styled-components";

const Styled = styled.div<{ x: number; y: number }>`
  position: fixed;

  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;

  display: flex;
  flex-direction: column;
  z-index: 6;
  background-color: white;

  border-radius: 0.5rem 0.5rem 0 0;
  border: 2px solid black;
`;

const StyledDragHandle = styled.div`
  cursor: grab;
`;

// TODO: This entire class should be replaced with a library
// that handles dragging for us, this was just a quick way to
// a MVP of calculator out, DO NOT USE THIS ELSEWHERE YET
type DraggableProps = {
  children: React.ReactNode;
};
const Draggable = (props: DraggableProps) => {
  const [position, setPosition] = React.useState({ x: 0, y: 0 });
  const handleMouseDown = (e: React.MouseEvent) => {
    const offsetX = e.clientX - position.x;
    const offsetY = e.clientY - position.y;

    // workaround: disable pointer events on iframes
    // to prevent them from stealing mouseover events
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      iframe.style.pointerEvents = "none";
    });

    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX - offsetX,
        y: e.clientY - offsetY,
      });
    };

    const handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);

      // re-enable pointer events on iframes
      iframes.forEach((iframe) => {
        iframe.style.pointerEvents = "auto";
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };
  return (
    <Styled x={position.x} y={position.y}>
      <StyledDragHandle onMouseDown={handleMouseDown}>
        <DragHandle />
      </StyledDragHandle>
      {props.children}
    </Styled>
  );
};

export default Draggable;

const DragHandle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="2.8rem"
      viewBox="0 0 200 200"
      fill="#e7e7e7"
    >
      <circle cx="40" cy="70" r="20" />
      <circle cx="100" cy="70" r="20" />
      <circle cx="160" cy="70" r="20" />
      <circle cx="40" cy="130" r="20" />
      <circle cx="100" cy="130" r="20" />
      <circle cx="160" cy="130" r="20" />
    </svg>
  );
};
